export const dateRegex = new RegExp(/([D]{1,2})|([M]{1,3})|([Y]{1,4})|(\W)+/);

export const dayInMonths = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
